import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class ProviderServiceLevel extends AbstractModel {
  @autoserialize
  providerId: number;

  @autoserialize
  serviceLevelId: number;

  @autoserialize
  active: boolean;
}
